import Geom, { POINT, POINT_HOVER, POINT_RADIUS, POINT_START, POINT_START_HOVER } from "./geom";
import { CONFIG } from "~/config";
import { node } from "~/util/dom";

/**
 * Bod geometrie.
 */
export default class Point extends Geom {
	_node: any;

	_marker: any;

	constructor(layer, scene) {
		super(layer, scene);
		this._node = null;
		this._marker = null;
		this._coords = null;

		delete this._geom;
		delete this._nodes;
	}

	/**
	 * Ziskani markeru.
	 */
	get marker() {
		return this._marker;
	}

	get node() {
		return this._node;
	}

	/**
	 * Odstraneni markeru.
	 */
	remove() {
		if (this._marker) {
			this._unbind();
			this._layer.removeMarker(this._marker);
			this._marker.destroy();
			this._marker = null;
			this._node = null;
		}
	}

	/**
	 * Nastaveni stylu markeru.
	 */
	setStyle(style) {
		if (!this._node) {
			return;
		}

		this._node.style.width = `${POINT_RADIUS*2}px`;
		this._node.style.height = `${POINT_RADIUS*2}px`;
		this._node.style.backgroundColor = style.color;
		this._node.style.border = `${style.outlineWidth}px solid ${style.outlineColor}`;
	}

	setNoEvents(noEvents = false) {
		this._node.style.pointerEvents = noEvents ? "none" : "";
	}

	/**
	 * bind elementu
	 */
	bindTo(bindScope: any = this) {
		this._bindScope = bindScope;

		if (!this._marker || !this._node) {
			return;
		}

		if (!CONFIG.inFrame) {
			if (!Mapy.Util.isMobile()) {
				this._node.addEventListener("pointerenter", this._bindScope);
				this._node.addEventListener("pointerleave", this._bindScope);
			}

			this._node.addEventListener("pointerup", this._bindScope);
		}

		this._node.addEventListener("pointerdown", this._bindScope);
	}

	/**
	 * Test, jestli dany element spada pod geometrii.
	 */
	elTest(testEl) {
		if (this._node === testEl || this._node.contains(testEl)) {
			return true;
		}

		return false;
	}

	/**
	 * Vytvoreni - normal nebo start point?
	 */
	create(isStart: boolean, coords: any, options: any = {}) {
		const style = {
			...isStart ? POINT_START : POINT,
			...options,
		};

		this._node = node("span", { className: "distancemeter-point" });
		this.setStyle(style);

		const marker = this._scene.createMarker(coords, null, {
			url: this._node,
			anchor: {
				left: POINT_RADIUS,
				top: POINT_RADIUS,
			},
			m3dData: {
				type: "distancemeter",
			},
		});

		return this._create(coords, marker);
	}

	/**
	 * Nastav nove souradnice bodu.
	 */
	set coords(coords: any) {
		if (this._marker) {
			this._coords = coords;
			this._marker.setCoords(coords);
		}
	}

	/**
	 * Vrat puvodni styl.
	 */
	clearStyle() {
		this.setStyle(POINT);
	}

	/**
	 * Vrat puvodni styl - start point.
	 */
	setStyleStart() {
		this.setStyle(POINT_START);
	}

	/**
	 * Nastaveni hoveru - pro true cerveny, jinak sedy.
	 */
	setHover(isStart, state) {
		if (isStart) {
			this.setStyle(state ? POINT_START : POINT_START_HOVER);
		} else {
			this.setStyle(state ? POINT : POINT_HOVER);
		}
	}

	_unbind() {
		if (!this._node) {
			return;
		}

		if (!CONFIG.inFrame) {
			if (!Mapy.Util.isMobile()) {
				this._node.removeEventListener("pointerenter", this._bindScope);
				this._node.removeEventListener("pointerleave", this._bindScope);
			}

			this._node.removeEventListener("pointerup", this._bindScope);
		}

		this._node.removeEventListener("pointerdown", this._bindScope);
	}

	_create(coords, marker) {
		this.remove();

		this._coords = coords;
		this._marker = marker;
		this._layer.addMarker(this._marker);

		return marker;
	}
}
